/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/hjj/bio_link_pc/src/components/work_bench/TransferDialog.vue';
import __unplugin_components_0 from 'D:/hjj/bio_link_pc/src/components/BaseButton.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'approval-transfer',
  props: ["origin_id", "approval_id"],
  emits: ["success"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var transferDialogVisible = ref(false);
    var transferParams = ref({});
    var toTransfer = () => {
      transferDialogVisible.value = true;
      transferParams.value.approval_id = props.approval_id;
    };
    var handleTransferSuccess = (selectedApprover, response) => {
      transferDialogVisible.value = false;
      emit("success", "transfer");
    };
    return (_ctx, _cache) => {
      var _component_BaseButton = __unplugin_components_0;
      var _component_TransferDialog = __unplugin_components_1;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_BaseButton, {
        style: {
          "margin-right": "10px"
        },
        text: "转他人",
        type: "transfer",
        onClick: toTransfer
      }), _createVNode(_component_TransferDialog, {
        modelValue: _unref(transferDialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(transferDialogVisible) ? transferDialogVisible.value = $event : null),
        title: "转他人",
        approverLabel: "审批人",
        "transfer-params": _unref(transferParams),
        onSuccess: handleTransferSuccess
      }, null, 8, ["modelValue", "transfer-params"])], 64);
    };
  }
};